import { createContext, useContext, useState, useEffect } from 'react'
import api from '../services/api'
import { getSocket, disconnectSocket } from '../services/socket'
import { desuscribirPush } from '../services/push'
import { desuscribirFcm } from '../services/fcm'

const AuthContext = createContext(null)
export const useAuth = () => useContext(AuthContext)

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null)
  const [empresa, setEmpresa] = useState(null)
  const [plan, setPlan] = useState(null)
  const [superAdmin, setSuperAdmin] = useState(null)
  const [cargando, setCargando] = useState(true)

  useEffect(() => { restaurar() }, [])

  async function restaurar() {
    const token = localStorage.getItem('token')
    const tipo  = localStorage.getItem('tipo')
    if (!token || !tipo) { setCargando(false); return }

    try {
      if (tipo === 'superadmin') {
        setSuperAdmin(JSON.parse(localStorage.getItem('admin') || 'null'))
      } else {
        const { data } = await api.get('/auth/me')
        setUsuario(data.usuario)
        setEmpresa(data.empresa)
        setPlan(data.plan)
        getSocket()
      }
    } catch { localStorage.clear() }
    setCargando(false)
  }

  function loginUsuario(data) {
    localStorage.setItem('token', data.token)
    localStorage.setItem('tipo', 'usuario')
    localStorage.setItem('usuario', JSON.stringify(data.usuario))
    localStorage.setItem('empresa', JSON.stringify(data.empresa))
    setUsuario(data.usuario)
    setEmpresa(data.empresa)
    setPlan(data.plan)
    getSocket()
  }

  function loginSuperAdmin(data) {
    localStorage.setItem('token', data.token)
    localStorage.setItem('tipo', 'superadmin')
    localStorage.setItem('admin', JSON.stringify(data.admin))
    setSuperAdmin(data.admin)
  }

  async function logout() {
    const cleanup = Promise.allSettled([
      api.post('/auth/logout'),
      desuscribirPush(),
      desuscribirFcm(),
    ])
    // Conserva la sesión lo suficiente para que las bajas autenticadas lleguen
    // al backend, sin bloquear el cierre si el dispositivo está sin conexión.
    await Promise.race([
      cleanup,
      new Promise((resolve) => setTimeout(resolve, 2500)),
    ])
    disconnectSocket()
    localStorage.clear()
    setUsuario(null); setEmpresa(null); setPlan(null); setSuperAdmin(null)
    window.location.href = '/login'
  }

  return (
    <AuthContext.Provider value={{ usuario, empresa, plan, superAdmin, cargando, loginUsuario, loginSuperAdmin, logout }}>
      {children}
    </AuthContext.Provider>
  )
}
